import type { PageEvent } from '@noths/polaris-client-next-components';
import type { _Omit } from '@noths/polaris-dev-ts-recipes';

import type { SelectedOptionValuesRecord } from 'src/redux/basket/types';
import type { ProductState } from 'src/redux/product/types';
import type { ProductFieldObject } from 'src/types/googleAnalytics';
import { generateProductFieldObject } from './googleAnalytics';

export type PageEcommerceObject = _Omit<ProductFieldObject, 'quantity'>;

export interface PageEventObject {
  ecommerce: {
    detail: { products: PageEcommerceObject[] };
  };
  page?: PageEvent['page'] & {
    bot_caching: 'true' | 'false';
    brand_rating?: string;
    external_referrer: boolean;
    layout_type: string;
  };
}

interface GetServerSidePageEventArgs {
  appVersion: string;
  externalReferrer: boolean;
  layoutType: string;
  optionsCount: number;
  partnerAverageProductRating?: number;
  productState: ProductState;
  requestIsFromBot: boolean;
  selectedOptionValues: SelectedOptionValuesRecord;
  version: string;
}

export const getServerSidePageEventObject = ({
  appVersion,
  externalReferrer,
  layoutType,
  optionsCount,
  partnerAverageProductRating,
  productState,
  requestIsFromBot,
  selectedOptionValues,
  version,
}: GetServerSidePageEventArgs): PageEventObject => {
  const productEcommerce: ProductFieldObject = {
    ...generateProductFieldObject({
      product: productState,
      selectedOptionValues,
    }),
    dimension92: String(optionsCount),
  };

  return {
    page: {
      bot_caching: requestIsFromBot ? 'true' : 'false',
      brand_rating: partnerAverageProductRating ? String(partnerAverageProductRating) : undefined,
      category: 'Product',
      environment: process.env.NODE_ENV,
      external_referrer: externalReferrer,
      layout_type: layoutType,
      react: 'true',
      app_version: appVersion,
      release_version: version,
    },
    ecommerce: {
      detail: {
        products: [productEcommerce],
      },
    },
  };
};
